import { Badge } from "@mantine/core";
import { MdCancel, MdCheckCircle, MdHourglassEmpty } from "react-icons/md";
import { IdeaReviewStatus } from "../../api";

export const CATEGORY_LABELS: Record<string, string> = {
    sales_productivity: "Sales Productivity",
    customer_engagement: "Customer Engagement",
    opportunity_identification: "Opportunity Identification",
    knowledge_and_learning: "Knowledge & Learning",
    content_creation: "Content Creation",
    proactive_intelligence: "Proactive Intelligence",
    clinical_support: "Clinical Support",
    integrations_and_data: "Integrations & Data",
    analytics_and_insights: "Analytics & Insights",
    other: "Other"
};

export const CATEGORY_COLORS: Record<string, string> = {
    sales_productivity: "blue",
    customer_engagement: "teal",
    opportunity_identification: "cyan",
    knowledge_and_learning: "indigo",
    content_creation: "violet",
    proactive_intelligence: "grape",
    clinical_support: "green",
    integrations_and_data: "orange",
    analytics_and_insights: "yellow",
    other: "gray"
};

export const IDEA_REVIEW_STATUS_OPTIONS: Array<{ value: IdeaReviewStatus; label: string }> = [
    { value: "new", label: "New" },
    { value: "reviewed", label: "Reviewed" },
    { value: "cancelled", label: "Cancelled" }
];

const REVIEW_STATUS_BADGES: Record<IdeaReviewStatus, { label: string; color: string; icon: React.ReactNode }> = {
    new: { label: "New", color: "blue", icon: <MdHourglassEmpty size={12} /> },
    reviewed: { label: "Reviewed", color: "teal", icon: <MdCheckCircle size={12} /> },
    cancelled: { label: "Cancelled", color: "gray", icon: <MdCancel size={12} /> }
};

/** Ideas stored before review status existed have none and count as new. */
export const ideaReviewStatus = (status?: IdeaReviewStatus | null): IdeaReviewStatus => status ?? "new";

export const IdeaReviewStatusBadge = ({ status }: { status?: IdeaReviewStatus | null }) => {
    const { label, color, icon } = REVIEW_STATUS_BADGES[ideaReviewStatus(status)];
    return (
        <Badge color={color} variant="light" size="sm" leftSection={icon}>
            {label}
        </Badge>
    );
};
